/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_UpdateInputs */

const es_feedback_modal_update = /** @type {(inputs: Feedback_Modal_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar cambios`)
};

const en_feedback_modal_update = /** @type {(inputs: Feedback_Modal_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save changes`)
};

/**
* | output |
* | --- |
* | "Save changes" |
*
* @param {Feedback_Modal_UpdateInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_update = /** @type {((inputs?: Feedback_Modal_UpdateInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_UpdateInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_update(inputs)
	return en_feedback_modal_update(inputs)
});
export { feedback_modal_update as "feedback.modal.update" }